// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */:host{display:block;position:relative}`, "",{"version":3,"sources":["webpack://./packages/builder-sales/leads/components/lead-board/virtual-rendering/virtual-list.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAKA,MACE,aAAA,CACA,iBAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n:host {\n  display: block;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
